/**
 * ローカルストレージからデフォルトのステータスフィルタ値を取得
 */
export const DISPLAY_CONTROLBOX_FILTER_KEY = "display-controlBox-filter-status";
export const displayControlBoxFilterStatus = (): string => {
  const storageStatus = localStorage.getItem(DISPLAY_CONTROLBOX_FILTER_KEY);
  if (!storageStatus) return "all";
  return JSON.parse(storageStatus);
};
